import React ,{useState,useEffect,useRef}from "react";
import { getData,postData } from "../../../../ApiServices/ApiService";
import { ORG_GET_ROLES_LIST,ORG_GET_TEAM_LIST,ORG_UPDATE_EMPLOYEE, ORG_EMP_REACENT_ACTIVITY,ORG_GET_EMP_PASSWORD,ORG_PASSOWRD_DECRYPT_KEY } from "../../../../ApiServices/BaseURL";
import { validateEmail } from "../../../../Utils/Validation";
import { useNavigate } from "react-router-dom";
import { logFrontendException } from '../../../../Utils/Exception';
import { useTheme } from "../../../../GlobalContext/GlobalContext";

const UserPrimaryInformationController = (userInfo,isUserEditable,userActivityList, onRefresh) => {
  const navigate = useNavigate();
    const [primaryData2, setPrimaryData2] = useState({
        "emp_id": null,
        "emp_name": "",
        "emp_email": "",
        "emp_mobile_no": "",
        "emp_mobile_code": "",
        "role_id": 0,
        "team_id": 0,
        "emp_status": 0,
        "emp_code": "EMP001",
        "emp_task_assign_flag": 0,
        "team_name": "",
        "emp_code": "",
        "emp_id_team_manager": null,
        "emp_id_team_lead": null,
        "emp_id_team_manager_name": "",
        "emp_id_team_lead_name": "",
        "role_id_name":""
    });
    const [isRoleLoading, setIsRoleLoading] = useState(false)
    const [roleError, setRoleError] = useState('');
    const rolesListRef = useRef([]);
    const [teamLoading, setTeamLoading] = useState(false)
    const [teamError, setTeamError] = useState('');
    const teamListRef = useRef([]);
    const [updateDeleteError,setUpdateDeleteError]=useState('');
    const [updateDeleteSuccess,setUpdateDeleteSuccess]=useState('');
    const [updateLoading,setUpdateLoading]=useState(false);
    const [primaryData, setPrimaryData] = useState(userInfo);
    const [fieldConfigs, setFieldConfigs] = useState([
        { label: "User Name", key: "emp_name", type: "text", error: "" },
        { label: "Email ID", key: "emp_email", type: "text", error: "" },
        { label: "Phone No.", key: "emp_mobile_no", type: "mobile", error: "" },
        { label: "Role", key: "role_id_name", type: "dropdown", options: rolesListRef.current,loading:isRoleLoading, error: "" },
        { label: "Date Of Joining", key: "employee_join_at", type: "date", error:"" },
        { label: "Employee ID", key: "emp_code", type: "text", error: "" },
        // { label: "Group Name", key: "groupName", type: "dropdown", options: ["Group A", "Group B"] },
        { label: "Team Name", key: "team_name", type: "dropdown", options: teamListRef.current,loading:teamLoading, error: "" },
        { label: "Team Leader", key: "emp_id_team_lead_name", type: "text"},
        { label: "Manager", key: "emp_id_team_manager_name", type: "text"},
    ]);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const pageName = 'UserPrimaryInformationController';
    const storedUserId = JSON.parse(localStorage.getItem("_userInfo_"))?.emp_id;
    const { setIsLoginPopup } = useTheme();
    useEffect(()=>{
        setPrimaryData(userInfo);
    },[userInfo])

  const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  }, [])

  //   useEffect(() => {
  //     if (userInfo?.emp_id) {
  //         fetchUserRecentActivity();
  //     }
  // }, [userInfo]);

    useEffect(()=>{
        if(isUserEditable){
            fetchRoleList();
            fetchTeamList();
        }

    },[isUserEditable])

    const fetchRoleList =async ()=>{
      try {
        setFieldConfigs((prevConfigs) =>
          prevConfigs.map((field) =>
            field.key === "role_id_name"
              ? { ...field, loading: true }
              : field
          )
        );
          setIsRoleLoading(true);
          setRoleError('');
          rolesListRef.current = [];
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
      
          // Make the API call
          const response = await getData(`${ORG_GET_ROLES_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
          const responseData = await response.json();
      
          // Check for success (200) and internal status code
          if (response?.status === 200) {
            if (responseData?.statusCode === 200) {
              if (responseData?.message.toLowerCase() === 'success') {
                if (responseData?.dataJ?.length > 0) {
                  // rolesListRef.current = responseData?.dataJ?.map(doc => {
                  //     const [key, value] = Object.entries(doc)[0]; // Extract the first key-value pair
                  //     return { label: value, value: key };
                  //   });
                  rolesListRef.current = await responseData?.dataJ.map(service => ({
                      label: service.role_name,
                      value: service.role_id
                    }));
                    setFieldConfigs((prevConfigs) =>
                      prevConfigs.map((field) =>
                        field.key === "role_id_name"
                          ? { ...field, options: rolesListRef.current }
                          : field
                      )
                    );
                } else {
                  setFieldConfigs((prevConfigs) =>
                    prevConfigs.map((field) =>
                        field.key === "role_id_name"
                            ? { ...field, error: responseData?.info || 'Data Not Found' }
                            : field
                    )
                );
                  setRoleError(responseData?.info || 'Data Not Found');
                  // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                  logFrontendException(storedUserId, pageName, "fetchRoleList", responseData?.info || '');
                }
              } else {
                setFieldConfigs((prevConfigs) =>
                  prevConfigs.map((field) =>
                      field.key === "role_id_name"
                          ? { ...field, error: responseData?.info || 'Failed to fetch Roles data. Please try again.' }
                          : field
                  )
              );
                  setRoleError(responseData?.info || 'Failed to fetch Roles data. Please try again.');
                  logFrontendException(storedUserId, pageName, "fetchRoleList", responseData?.info || '');
              }
            } else {
              setFieldConfigs((prevConfigs) =>
                prevConfigs.map((field) =>
                    field.key === "role_id_name"
                        ? { ...field, error: responseData?.info || 'Failed to fetch Roles data.' }
                        : field
                )
            );
              setRoleError(responseData?.info || 'Failed to fetch Roles data.');
              logFrontendException(storedUserId, pageName, "fetchRoleList", responseData || '');
            }
          } else {
            setFieldConfigs((prevConfigs) =>
              prevConfigs.map((field) =>
                  field.key === "role_id_name"
                      ? { ...field, error: 'Unexpected error occurred. Please try again later.' }
                      : field
              )
          );
              setRoleError('Unexpected error occurred. Please try again later.');
              logFrontendException(storedUserId, pageName, "fetchRoleList", response || '');
          }
        } catch (error) {
          setFieldConfigs((prevConfigs) =>
            prevConfigs.map((field) =>
                field.key === "role_id_name"
                    ? { ...field, error: 'Failed to fetch Roles List. Please check your network connection and try again.' }
                    : field
            )
        );
          setRoleError(`Failed to fetch Roles List. Please check your network connection and try again.`);
          logFrontendException(storedUserId, pageName, "fetchRoleList", error || '');
        } finally {
          setIsRoleLoading(false);
          setFieldConfigs((prevConfigs) =>
            prevConfigs.map((field) =>
              field.key === "role_id_name"
                ? { ...field, loading: false }
                : field
            )
          );
        }
    }

   const fetchTeamList = async () => {
      try {
          setFieldConfigs((prevConfigs) =>
              prevConfigs.map((field) =>
                  field.key === "team_name"
                      ? { ...field, loading: true }
                      : field
              )
          );
          setTeamLoading(true);
          setTeamError('');
          teamListRef.current = [];
          const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

          // Make the API call
          const response = await getData(`${ORG_GET_TEAM_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
          const responseData = await response.json();

          // Check for success (200) and internal status code
          if (response?.status === 200) {
              if (responseData?.statusCode === 200) {
                  if (responseData?.message.toLowerCase() === 'success') {
                      if (responseData?.dataJ?.length > 0) {
                          teamListRef.current = await responseData?.dataJ
                          .filter(service => service.team_status === 1).map(service => ({
                              label: service.team_name,
                              value: service.team_id,
                              team_manager: service.emp_id_team_manager_name,
                              team_leader: service.emp_id_team_lead_name
                          }));
                          setFieldConfigs((prevConfigs) =>
                              prevConfigs.map((field) =>
                                  field.key === "team_name"
                                      ? { ...field, options: teamListRef.current }
                                      : field
                              )
                          );
                      } else {
                          setTeamError(responseData?.info || 'Data Not Found');
                          setFieldConfigs((prevConfigs) =>
                              prevConfigs.map((field) =>
                                  field.key === "team_name"
                                      ? { ...field, error: responseData?.info || 'Data Not Found' }
                                      : field
                              )
                          );
                          logFrontendException(storedUserId, pageName, "fetchTeamList", responseData?.info || '');
                      }
                  } else {
                      setTeamError(responseData?.info || 'Failed to fetch team data. Please try again.');
                      setFieldConfigs((prevConfigs) =>
                          prevConfigs.map((field) =>
                              field.key === "team_name"
                                  ? { ...field, error: responseData?.info || 'Failed to fetch team data. Please try again.' }
                                  : field
                          )
                      );
                      logFrontendException(storedUserId, pageName, "fetchTeamList", responseData?.info || '');
                  }
              } else {
                  setTeamError(responseData?.info || 'Failed to fetch team data.');
                  setFieldConfigs((prevConfigs) =>
                      prevConfigs.map((field) =>
                          field.key === "team_name"
                              ? { ...field, error: responseData?.info || 'Failed to fetch team data.' }
                              : field
                      )
                  );
                  logFrontendException(storedUserId, pageName, "fetchTeamList", responseData || '');
              }
          } else {
              setTeamError('Unexpected error occurred. Please try again later.');
              setFieldConfigs((prevConfigs) =>
                  prevConfigs.map((field) =>
                      field.key === "team_name"
                          ? { ...field, error: 'Unexpected error occurred. Please try again later.' }
                          : field
                  )
              );
              logFrontendException(storedUserId, pageName, "fetchTeamList", response || '');
          }
      } catch (error) {
          setTeamError(`Failed to fetch team data. Please check your network connection and try again.`);
          setFieldConfigs((prevConfigs) =>
              prevConfigs.map((field) =>
                  field.key === "team_name"
                      ? { ...field, error: 'Failed to fetch team data. Please check your network connection and try again.' }
                          : field
              )
          );
          logFrontendException(storedUserId, pageName, "fetchTeamList", error || '');
      } finally {
          setTeamLoading(false);
          setFieldConfigs((prevConfigs) =>
              prevConfigs.map((field) =>
                  field.key === "team_name"
                      ? { ...field, loading: false }
                      : field
              )
          );
      }
  }

    const handleInputChange = (key, fieldData) => {
        // setPrimaryData((prevState) => ({
        //     ...prevState,
        //     [key]: value,
        // }));
        setPrimaryData((prev) => {
            // If the key is "emp_id_team_manager_name", update label and related ID
            if (key === "team_name") {
              return {
                ...prev,
                [key]: fieldData?.label, // Set the label in emp_id_team_manager_name
                team_id: fieldData?.value, // Set the value in emp_id_team_manager
                emp_id_team_lead_name:fieldData.team_leader,
                emp_id_team_manager_name:fieldData.team_manager

              };
            }
            if (key === "role_id_name") {
              const updatedData = {
                ...prev,
                [key]: fieldData?.label,
                role_id: fieldData?.value,
              };
          
              if (fieldData.value === 102) {
                updatedData.team_id = 0;
                updatedData.team_name = "";
                updatedData.emp_id_team_lead_name = "";
                updatedData.emp_id_team_manager_name = "";
              }
          
              return updatedData;
            }
            // For other keys, update normally
            return {
              ...prev,
              [key]: fieldData, // Update with the provided value
            };
          });
    };

    const handleUpdateUser = () => {
      console.log('handleUpdateUser')
      // setSelectedEmployee({ doc, index }); // Store the credential to delete
      // categoryInfoRef.current = doc;
      setIsEditModalOpen(true); // Open the confirmation modal
  };

  const handleOpenEditModal = () => {
      setIsEditModalOpen(true); // Open the modal
  };

  const handleCloseEditModal = () => {
      setIsEditModalOpen(false); // Close the modal
  };

    
    const callUpdateUser = async () => {
        //console.log('handleUpdateUser @@@');

            try {
              const updatedFieldConfigs = fieldConfigs.map((field) => ({
                ...field,
                error: "", // Reset errors initially for all fields
              }));
            
              let hasError = false;
            
              // Validate each field based on its key
              const validatedFields = updatedFieldConfigs.map((field) => {
                let error = "";
                const value = primaryData?.[field.key]; // Retrieve the value for this field using its key
            
                // Validation logic based on the key
                switch (field.key) {
                  case "emp_name":
                  case "emp_code":
                    const trimmedEmpCode = value?.trim() || "";
                    if (!trimmedEmpCode) {
                      error = `${field?.label} is required.`;
                      hasError = true;
                    } else if (trimmedEmpCode.length > 15) {
                      error = `${field?.label} must be 15 characters or less.`;
                      hasError = true;
                    }
                    break;
                  case "employee_join_at":
                    if (!value?.trim()) {
                      error = `${field?.label} is required.`;
                      hasError = true;
                    }
                    break;
                  case "emp_email":
                    if (!validateEmail(value)) {
                      error = `Invalid Email Address`;
                      hasError = true;
                    }
                    break;
                  case "emp_mobile_no":
                    if (!value || value.length !== 10 || !/^\d+$/.test(value)) {
                      error = `${field?.label} must be a valid 10-digit number.`;
                      hasError = true;
                    }
                    break;
                  default:
                    break;
                }

                return { ...field, error }; // Attach the error message to the field
              });
    
              // Update fieldConfigs with errors
              setFieldConfigs(validatedFields);
    
              if (hasError) {
                 return; // Stop submission if there are validation errors
              }

                setUpdateDeleteError('');
                setUpdateDeleteSuccess('');
                setUpdateLoading(true);
                const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
                const payLoad={
                    "emp_id_auth": storedUserInfo?.emp_id,
                    "emp_id": primaryData?.emp_id,
                    "action": "update_emp_primary_info",
                    "emp_name": primaryData?.emp_name,
                    "emp_email": primaryData?.emp_email,
                    "emp_mobile_no": primaryData?.emp_mobile_no,
                    "emp_mobile_code": primaryData?.emp_mobile_code,
                    "role_id": primaryData?.role_id,
                    "team_id": primaryData?.team_id,
                    "employee_join_at":primaryData?.employee_join_at,
                    "emp_code": primaryData?.emp_code
                }
                // console.log('update user payload:---',payLoad);
                const response = await postData(ORG_UPDATE_EMPLOYEE,payLoad);
                const responseData = await response.json();
            
                if (response?.status === 200) {
                  if (responseData?.status_code === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                      setUpdateDeleteSuccess(responseData?.info || 'User primary information got updated successfully.');
                      setTimeout(() => {
                        onRefresh();
                        setUpdateDeleteSuccess('')
                      }, 3000);
                    } else {
                      setUpdateDeleteError(responseData?.info || 'Failed to update user primary information. Please try again.');
                      // ⛔️ Log exception to backend (User Id,Page Name,Method Name,Response/error)
                      logFrontendException(storedUserId, pageName, "callUpdateUser", responseData?.info || '');
                    }
                  } else {
                    setUpdateDeleteError(responseData?.info || 'Failed to update user primary information.');
                    logFrontendException(storedUserId, pageName, "callUpdateUser", responseData || '');
                  }
                }  // Token-related errors: 400, 401, 403
                else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                    setUpdateDeleteError('Unauthorized access. Your session may have expired. Please log in again.');
                    logFrontendException(storedUserId, pageName, "callUpdateUser", response || '');
                    setIsLoginPopup(true)
                } else {
                  setUpdateDeleteError('Error ocurred while updating user primary information.');
                  logFrontendException(storedUserId, pageName, "callUpdateUser", response || '');
                }
              } catch (error) {
                setUpdateDeleteError(`Failed to update user primary information. Please check your network connection and try again.`);
                logFrontendException(storedUserId, pageName, "callUpdateUser", error || '');
              } finally {
                setUpdateLoading(false);
              }
    }

    const handleCancel = () => {
      navigate(-1);
    }

    const getStatusStyle = (status) => {
      switch (true) {
        case status?.task_status_name?.toLowerCase() === 'delayed':
          return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
        case status?.task_status_name?.toLowerCase() === 'not started':
          return { backgroundColor: "#fff3cd", color: "#DFA510" }; // Yellow
        case status?.task_status_name?.toLowerCase() === 'in progress':
          return { backgroundColor: "#d4edda", color: "#155724" }; // Green
        case status?.task_status_name?.toLowerCase() === 'completed':
          return { backgroundColor: "#c7c4c32e", color: "#7b7b7b" }; // Gray
        case status?.task_status_name?.toLowerCase() === 'priority':
          return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
        case status?.task_status_name?.toLowerCase() === 'hold':
          return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
        case status?.task_status_name?.toLowerCase() === 'issue':
          return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
          case status?.task_status_name?.toLowerCase() === 'overdue':
            return { backgroundColor: "#f8d7da", color: "#721c24" }; // Red
  
        default:
          return {};
      }
    };

    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(userActivityList?.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTasks = userActivityList?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();

  const[password, setPassword] = useState('');
  const[passwordLoading, setPasswordLoading] = useState(false);
  const[passwordError, setPasswordError] = useState('');

//   function decodeBase64ToBytes(base64Str) {
//     base64Str = base64Str.replace(/-/g, '+').replace(/_/g, '/');
//     while (base64Str.length % 4 !== 0) {
//         base64Str += '=';
//     }
//     const binaryStr = atob(base64Str);
//     const bytes = new Uint8Array(binaryStr.length);
//     for (let i = 0; i < binaryStr.length; i++) {
//         bytes[i] = binaryStr.charCodeAt(i);
//     }
//     return bytes;
// }

// const decryptPassword1 = (encryptedBase64, keyBase64) => {
//     try {
//         const encryptedBytes = decodeBase64ToBytes(encryptedBase64);
//         const keyBytes = decodeBase64ToBytes(keyBase64);

//         const resultBytes = new Uint8Array(encryptedBytes.length);
//         for (let i = 0; i < encryptedBytes.length; i++) {
//             resultBytes[i] = (256 + encryptedBytes[i] - keyBytes[i % keyBytes.length]) % 256;
//         }

//         // Decode final byte array to string
//         const decoder = new TextDecoder("utf-8");
//         return decoder.decode(resultBytes);
//     } catch (err) {
//         console.error("Decryption failed:", err);
//         return null;
//     }
// };

const decryptPassword = (encryptedText, key) => {
  try {
    const encrypted = window.atob(encryptedText.replace(/-/g, '+').replace(/_/g, '/'));
    let result = '';
    for (let i = 0; i < encrypted.length; i++) {
      const encryptedCharCode = encrypted.charCodeAt(i);
      const keyCharCode = key.charCodeAt(i % key.length);
      const originalCharCode = (256 + encryptedCharCode - keyCharCode) % 256;
      result += String.fromCharCode(originalCharCode);
    }
    return result;
  } catch (err) {
    console.error("Decryption failed:", err);
    return null;
  }
};

const [passwordVisible, setPasswordVisible] = useState(false);
  const handleGetEmpPassword = async () => {
    if (password) {
      setPasswordVisible(!passwordVisible);
      return;
    }
    if (!primaryData?.emp_id) {
      return;
    }
    setPasswordLoading(true);
    setPasswordError("");
    setPassword('');
    setPasswordVisible(true);

    try {
        const storedUserInfo = JSON.parse(localStorage.getItem("_userInfo_"));

        const response = await getData(`${ORG_GET_EMP_PASSWORD}?emp_id=${primaryData?.emp_id}`);
        const responseData = await response.json();

        if (response.status === 200 ) {
          if(responseData.statusCode === 200){
            if( responseData?.message.toLowerCase() === 'success'){
              const encryptedPassword = responseData?.dataJ;
                const encryptionKey = 'w4jDgsOow4LDmMOCw5bDilrDpsOew5jDqsOow5LDnsOcw6Zcw4bDnsOa'
                if (!encryptedPassword || encryptedPassword.length === 0) {
                  setPasswordError("No password found.");
              } else{
                const decrypted = decryptPassword(encryptedPassword, encryptionKey);
                console.log("decrypted password", decrypted);
                setPassword(decrypted);
              }
          }else{
            setPasswordError(responseData?.info || "Failed to fetch password.");
            logFrontendException(storedUserId, pageName, "emplPassword", responseData?.info || '');
          }

          }else{
            setPasswordError(responseData?.info || "Failed to fetch password.")
            logFrontendException(storedUserId, pageName, "emplPassword", responseData?.info || '');
          }
          
              
        }else if(response?.status === 400 || response?.status === 401 || response?.status === 403){
          setPasswordError('Unauthorized access. Your session may have expired. Please log in again.')
          logFrontendException(storedUserId, pageName, "emplPassword", responseData || '');
        }
         else {
          setPasswordError("Unexpected error occurred. Please try again later.");
          logFrontendException(storedUserId, pageName, "emplPassword", responseData || '');
        }
    } catch (err) {
      setPasswordError("Failed to Show Password. Please check your network connection and try again.");
      logFrontendException(storedUserId, pageName, "emplPassword", err || '');
    } finally {
      setPasswordLoading(false);
    }
};

    return {
        handleUpdateUser,
        handleCancel,
        fieldConfigs,
        primaryData,
        handleInputChange,
        updateDeleteError,
        updateDeleteSuccess,
        updateLoading,
        isEditModalOpen,
        handleOpenEditModal,
        handleCloseEditModal,
        callUpdateUser,
        getStatusStyle,
        visiblePages,
        currentTasks,
        currentPage,
        totalPages,
        handlePageChange,
        handleGetEmpPassword,
        passwordError,
        passwordLoading,
        password,
        passwordVisible,userPermissions
    };

}

export default UserPrimaryInformationController;